module.exports = __webpack_public_path__ + "img/cvc.6c05b903.svg";